export default __webpack_public_path__ + "static/media/greyStepIncomplete.df3e6f4f.svg";